export const SERVICES = [
  {
    id: "setup",
    num: "01",
    name: "TikTok Shop 开店咨询",
    short: "协助你了解店铺申请流程、所需资料、基本设置，以及上线前需要注意的事项。",
    href: "/tiktok-shop-setup",
  },
  {
    id: "store-optimisation",
    num: "02",
    name: "店铺优化",
    short: "整理好店铺资料、商品结构、标题、描述、图片和整体店铺形象。",
    href: "/tiktok-shop-management",
  },
  {
    id: "listing",
    num: "03",
    name: "商品上架与优化",
    short: "提升每个商品页面的清晰度、完整度和购买体验。",
    href: "/product-optimisation",
  },
  {
    id: "content",
    num: "04",
    name: "短视频内容方向",
    short: "根据你的产品、客户群和马来西亚市场情况，规划适合的短视频内容方向。",
    href: "/content-strategy",
  },
  {
    id: "operations",
    num: "05",
    name: "日常店铺运营",
    short: "为你的 TikTok Shop 提供日常管理和运营方面的持续支持。",
    href: "/tiktok-shop-management",
  },
  {
    id: "campaign",
    num: "06",
    name: "活动与促销规划",
    short: "协助规划适合你利润和库存情况的促销、产品组合和活动方向。",
    href: "/tiktok-shop-management",
  },
  {
    id: "consultation",
    num: "07",
    name: "卖家一对一咨询",
    short: "已经在经营店铺、但遇到具体问题的卖家，可以预约一对一咨询。",
    href: "/services#seller-consultation",
  },
];

export const CONSIDERATIONS = [
  { num: "01", title: "开店需要准备什么？" },
  { num: "02", title: "已经有 Shopee，还需要做 TikTok Shop 吗？" },
  { num: "03", title: "没有团队可以开始吗？" },
  { num: "04", title: "做了之后谁负责内容和店铺？" },
];

export const OPPORTUNITIES = [
  { title: "多一条出单渠道", desc: "不只依赖实体店或单一电商平台。" },
  { title: "产品靠内容被看到", desc: "短视频和直播直接带动购买。" },
  { title: "接触新的客户群", desc: "让不认识你品牌的人也有机会下单。" },
  { title: "可以小规模开始", desc: "先跑通适合的产品，再逐步扩大。" },
];

export const MERCHANT_TYPES = [
  {
    key: "physical_business",
    num: "01",
    title: "已有实体生意",
    desc: "已经有产品和客户，希望增加线上销售渠道。",
    cta: "我是实体商家",
  },
  {
    key: "existing_ecommerce",
    num: "02",
    title: "已在 Shopee / Lazada 销售",
    desc: "已经有电商经验，希望进一步了解 TikTok Shop。",
    cta: "我已经在做电商",
  },
  {
    key: "brand_supplier",
    num: "03",
    title: "品牌 / 产品供应商",
    desc: "希望让自己的产品进入更多线上销售渠道。",
    cta: "我是品牌 / 供应商",
  },
  {
    key: "new_to_ecommerce",
    num: "04",
    title: "有产品，但还没做电商",
    desc: "不知道自己的产品适不适合，也不知道应该怎样开始。",
    cta: "帮我看看产品",
  },
];

export const STAGES = [
  {
    key: "exploring",
    num: "01",
    title: "正在了解",
    desc: "听过 TikTok Shop，但还不知道是否适合自己的生意。",
    cta: "我想先了解",
  },
  {
    key: "ready_to_start",
    num: "02",
    title: "准备开始",
    desc: "已经有产品，希望了解开店和准备流程。",
    cta: "我准备开始",
  },
  {
    key: "existing_shop",
    num: "03",
    title: "已经开店",
    desc: "店铺已经建立，希望改善商品、内容和整体运营。",
    cta: "我已经开店",
  },
  {
    key: "managed_service",
    num: "04",
    title: "想找团队协助",
    desc: "没有完整内部团队，希望有人协助后续运营。",
    cta: "了解运营支持",
  },
];

export const HOME_SERVICES = [
  {
    key: "setup",
    name: "TikTok Shop 开店支持",
    desc: "从准备到店铺上线。",
    cta: "问开店",
    href: "/tiktok-shop-setup",
  },
  {
    key: "optimisation",
    name: "商品与店铺优化",
    desc: "改善商品页面与店铺呈现。",
    cta: "看看我的店",
    href: "/product-optimisation",
  },
  {
    key: "content",
    name: "内容方向规划",
    desc: "根据产品规划适合的内容方向。",
    cta: "咨询内容",
    href: "/content-strategy",
  },
  {
    key: "operations",
    name: "日常运营支持",
    desc: "协助 Campaign、店铺管理和日常工作。",
    cta: "了解运营",
    href: "/tiktok-shop-management",
  },
];

export const AUDIENCES = [
  {
    num: "01",
    title: "新手卖家",
    desc: "第一次接触 TikTok Shop，希望有人带你看清整个流程 —— 从申请到第一个商品上架。",
  },
  {
    num: "02",
    title: "SME / 本地商家",
    desc: "本来已经有实体店或其他销售渠道，想增加一个认真经营的线上电商渠道。",
  },
  {
    num: "03",
    title: "现有 TikTok Shop 卖家",
    desc: "店铺已经在经营，但商品页面、内容或日常运营明显还有改善空间。",
  },
  {
    num: "04",
    title: "品牌商家",
    desc: "希望在马来西亚市场建立更完整、更专业的 TikTok Shop 品牌形象。",
  },
];

export const IMPROVE_AREAS = [
  { name: "店铺基础", note: "资料、物流与收款设置" },
  { name: "商品呈现", note: "标题、图片、价格" },
  { name: "内容方向", note: "适合产品的内容" },
  { name: "购买体验", note: "从内容到下单" },
  { name: "店铺管理", note: "订单、消息、评价" },
  { name: "活动规划", note: "优惠与平台活动" },
  { name: "转化体验", note: "减少购买流失" },
  { name: "长期运营", note: "稳定经营节奏" },
];

export const WHY_POINTS = [
  {
    title: "先看产品，再谈方案",
    desc: "不同产品不应该用同一套做法。",
  },
  {
    title: "从马来西亚市场出发",
    desc: "主要服务本地商家和 SME。",
  },
  {
    title: "不只是开店",
    desc: "后续商品、内容和运营都可以继续协助。",
  },
  {
    title: "先了解，再决定",
    desc: "可以先通过 Live Chat 了解自己的情况。",
  },
];

export const STEPS = [
  {
    num: "01",
    title: "先了解你的产品",
    desc: "卖什么、价格、客户是谁、目前在哪里销售。",
  },
  {
    num: "02",
    title: "看是否适合 TikTok Shop",
    desc: "了解产品、市场和现有销售情况。",
  },
  {
    num: "03",
    title: "准备店铺和商品",
    desc: "处理基础店铺设置、商品页面和上线准备。",
  },
  {
    num: "04",
    title: "开始经营并持续优化",
    desc: "根据实际情况处理内容、Campaign 和日常运营。",
  },
];

export const PREPARATION = [
  { title: "商业资料", desc: "公司注册（SSM）资料或个人卖家资料，以及用于收款的银行户口。" },
  { title: "商品资料", desc: "清楚的商品名称、规格、价格、库存；如适用，准备好相关认证（例如 HALAL、NOT）。" },
  { title: "商品图片", desc: "干净的商品照片 —— 我们可以建议你在 TikTok Shop 上适合的拍摄角度和呈现方式。" },
  { title: "物流准备", desc: "包装材料和基本的发货安排，确保订单可以准时寄出。" },
];

export const FAQS = [
  {
    q: "TKShopMY 是什么？",
    a: "TKShopMY 是一家服务马来西亚市场的独立电商运营服务团队，主要为本地商家提供 TikTok Shop 开店咨询、店铺运营、商品优化、内容方向及卖家支持服务。我们与 TikTok 官方没有任何关联。",
  },
  {
    q: "TikTok Shop 马来西亚要怎样开始？",
    a: "你需要在 TikTok Shop Seller Center 注册卖家账号，准备好个人或公司资料、银行户口和取货地址，然后上架第一批商品。步骤本身不难，但开店初期的设置决定（类别、店铺资料、物流）会影响之后的表现。不确定怎样开始，可以直接 WhatsApp 问我们。",
  },
  {
    q: "还没有 TikTok Shop，可以先咨询吗？",
    a: "可以。很多来找我们的商家，其实还在考虑自己的产品适不适合 TikTok Shop。直接 WhatsApp 我们，告诉我们你卖什么（或打算卖什么），我们会坦白告诉你下一步该怎样做 —— 不需要任何承诺。",
  },
  {
    q: "已经有 TikTok Shop 了，还可以找你们吗？",
    a: "可以，而且这是我们工作的很大一部分：改善商品页面、店铺形象、内容方向、活动规划或日常运营。告诉我们你觉得卡在哪里，我们会建议先处理什么。",
  },
  {
    q: "你们可以帮忙做什么？",
    a: "开店咨询、店铺与商品页面优化、商品上架支持、内容方向规划、日常店铺运营、活动与促销规划，以及卖家一对一咨询。完整内容可以看我们的服务页面。",
  },
  {
    q: "你们会保证我的店铺有订单吗？",
    a: "不会 —— 任何人这样保证你，你都应该小心。TikTok Shop 的审核、流量分配和平台政策都由 TikTok Shop 独立决定。我们提供的是实际的电商咨询、运营和内容支持，根据你的真实情况给出建议。",
  },
  {
    q: "TikTok Shop 开通后多久会有销量？",
    a: "没有固定答案。取决于你的产品、定价、商品页面质量、内容和活动配合。我们的工作是把这些环节做好，让店铺有公平的机会 —— 而不是承诺一个数字。",
  },
  {
    q: "开店需要准备什么资料？",
    a: "个人卖家：个人身份资料和银行户口。公司：SSM 注册资料和公司银行户口。部分商品类别需要额外的认证文件。第一次聊天时，我们会根据你的情况确认具体清单。",
  },
  {
    q: "一定要有公司（SSM）吗？",
    a: "不一定。个人卖家也可以在马来西亚开 TikTok Shop，不过注册公司在部分类别和功能上会更方便。我们可以根据你的产品类型解释两者的分别。",
  },
  {
    q: "个人卖家可以找你们吗？",
    a: "可以。我们服务个人卖家、居家生意、SME 和品牌商家。建议会根据你的规模调整 —— 居家生意适合的做法，和品牌商家不一样。",
  },
  {
    q: "你们可以帮忙管理店铺吗？",
    a: "可以。日常店铺运营是我们的核心服务之一，包括日常管理、商品维护、活动配合和运营支持。具体范围会根据你的店铺规模，在开始前先谈清楚。",
  },
  {
    q: "你们可以帮忙规划短视频内容吗？",
    a: "可以。内容方向是我们的独立服务：根据你的产品、目标客户和马来西亚市场目前有效的做法，规划内容角度、形式和发布节奏。方向由我们规划，品牌声音由你掌控。",
  },
  {
    q: "我的产品适不适合 TikTok Shop？",
    a: "要看产品类别、价格、利润，以及产品能不能通过视频展示清楚。这是我们最常被问到的问题 —— 直接在线告诉我们你卖什么，我们会直接回答你。",
  },
  {
    q: "TikTok Shop 代运营 / 管理费用是多少？",
    a: "取决于服务范围 —— 一次性开店咨询和长期店铺管理的定价不同。我们没有固定配套，因为每个店铺的情况不一样。在线告诉我们你的需求，我们会在开始前给你清楚的报价。",
  },
  {
    q: "合作前可以先了解清楚吗？",
    a: "可以 —— 这也是我们希望的方式。直接 WhatsApp 我们，有什么都可以问。不用填表格、不用付费、没有义务，先问清楚再决定。",
  },
  {
    q: "TikTok Shop 代运营公司通常做什么？",
    a: "代运营公司处理店铺的日常运营工作：商品上架、店铺形象、活动规划、内容方向和日常管理，让商家可以专注于产品和出货。TKShopMY 专注在马来西亚市场提供这些服务。",
  },
  {
    q: "什么是一件代发？",
    a: "一件代发通常指商家不需要自己处理大量库存和每一笔订单的发货流程，而是由合作方按照订单安排后续履约。实际合作方式会根据产品和方案而不同。",
  },
  {
    q: "一定需要自己囤货吗？",
    a: "不一定。TKShopMY 可提供不同合作方式咨询，包括无需自行囤货的模式。是否适合，需要根据产品、销售方式和实际合作条件判断。",
  },
  {
    q: "TKShopMY 是 TikTok 官方吗？",
    a: "不是。TKShopMY 是独立的马来西亚电商运营服务团队，并非 TikTok 官方、TikTok Shop 官方代理或其关联机构。TikTok、TikTok Shop 及相关商标属于其各自权利人。",
  },
];

export const HOME_FAQS = [
  {
    q: "我的产品适合 TikTok Shop 吗？",
    a: "不同产品情况不同。可以先告诉我们你卖什么、价格范围和目前销售渠道，我们会先了解情况，再给你实际的看法。",
  },
  {
    q: "没有 TikTok Shop，可以先咨询吗？",
    a: "可以。很多商家都是在正式开始之前，先了解产品和开店流程，再决定要不要做。",
  },
  {
    q: "已经有 Shopee / Lazada，还适合做 TikTok Shop 吗？",
    a: "可以视产品和经营情况考虑增加新的线上渠道。具体适不适合，需要结合你的产品和目标客户判断。",
  },
  {
    q: "没有团队可以做 TikTok Shop 吗？",
    a: "可以先从基础开始。后续如果需要，也可以了解运营支持，不需要一开始就有完整团队。",
  },
  {
    q: "TKShopMY 是 TikTok 官方吗？",
    a: "不是。TKShopMY 是独立的马来西亚电商服务团队，并非 TikTok 或 TikTok Shop 官方机构或关联公司。",
  },
];

export const HOME_FAQ_COUNT = 5;
